import { apolloClient } from '@/services/apollo';
import moment from 'moment-timezone'
import { ListMembers } from '@/gql/members/Members.gql'

async function listMembers(limit, offset){
  let data = await apolloClient.query({
    query: ListMembers,
    variables: {
      limit: limit,
      offset: offset
    },
  })
  return data.data.members.map(m => {
    m.successfulCallCount = m.recentCalls.filter(c => (c.status == 'completed')).length;
    m.latestCall = m.recentCalls[0] ? m.recentCalls[0].createdAt : 0;
    const elapsed = Date.now() - (new Date(m.latestCall).getTime());
    const localHour = moment.tz(new Date(), m.timezone).format('HH') * 1;
    m.actionable = (
      !m.successfulCallCount // No successful calls
      && (elapsed > (1000*60*60*24)) // Last attempted more than 1 day ago
      && (9 > localHour < 18) //Reasonable time to call
    )
    m._rowVariant = m.actionable ? 'success' : 'danger';
    return m;
  });
}

export default {
  listMembers
}
